import { render, staticRenderFns } from "./KolHistory.vue?vue&type=template&id=55dc1360&scoped=true"
import script from "./KolHistory.vue?vue&type=script&lang=js"
export * from "./KolHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55dc1360",
  null
  
)

export default component.exports